import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail, BACKEND_URL } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { Save, PlugZap } from "lucide-react";

export function VenergiaKeysCard() {
  const [s, setS] = useState(null);
  const [form, setForm] = useState({ api_key: "", webhook_secret: "" });
  const [busy, setBusy] = useState(false);
  const [test, setTest] = useState(null);
  useEffect(() => { api.get("/admin/greenpower/settings").then((r) => setS(r.data)).catch(() => setS({ error: true })); }, []);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/greenpower/settings", { api_key: form.api_key || null, webhook_secret: form.webhook_secret || null });
      setS(data); setForm({ api_key: "", webhook_secret: "" }); toast.success("Chiavi Venergia salvate");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore"); }
    finally { setBusy(false); }
  };
  const runTest = async () => {
    setTest(null);
    try { const { data } = await api.post("/admin/greenpower/test"); setTest(data); }
    catch (e) { setTest({ ok: false, error: formatApiErrorDetail(e.response?.data?.detail) }); }
  };
  if (!s) return null;
  if (s.error) return <p className="text-sm text-amber-500" data-testid="gp-keys-error">Impostazioni Venergia non disponibili.</p>;
  return (
    <Card className="p-5 glow-border space-y-4" data-testid="gp-admin-settings-card">
      <div className="flex flex-wrap items-center justify-between gap-2"><h2 className="font-head font-semibold">Venergia · chiavi API</h2><Badge variant="outline" data-testid="gp-keys-status">{s.api_key_set ? "Configurato" : "Da configurare"}</Badge></div>
      <div className="grid sm:grid-cols-2 gap-3">
        <div><Label>Chiave API (gpag_…)</Label><Input className="mt-1.5 font-mono" type="password" data-testid="gp-admin-key" value={form.api_key} onChange={(e) => setForm({ ...form, api_key: e.target.value })} placeholder={s.api_key_set ? `Salvata: ${s.api_key_hint}` : "Incolla la chiave"} /></div>
        <div><Label>Segreto avvisi (webhook)</Label><Input className="mt-1.5 font-mono" type="password" data-testid="gp-admin-secret" value={form.webhook_secret} onChange={(e) => setForm({ ...form, webhook_secret: e.target.value })} placeholder={s.webhook_secret_set ? "Salvato" : "Dal portale sviluppatori"} /></div>
      </div>
      <div className="rounded-lg border border-border p-3 text-xs">Indirizzo avvisi da inserire nel portale sviluppatori: <span className="font-mono break-all" data-testid="gp-admin-webhook-url">{BACKEND_URL}{s.webhook_path}</span></div>
      <div className="flex gap-2 flex-wrap">
        <Button onClick={save} disabled={busy || (!form.api_key && !form.webhook_secret)} className="gap-2" data-testid="gp-admin-save-keys"><Save className="w-4 h-4" /> Salva chiavi</Button>
        <Button variant="outline" onClick={runTest} className="gap-2" data-testid="gp-admin-test"><PlugZap className="w-4 h-4" /> Verifica chiave</Button>
      </div>
      {test && <div className="text-sm" data-testid="gp-admin-test-result">{test.ok ? <p className="text-teal-500">Collegato: {test.agenzia} · ambiente <Badge variant="outline">{test.ambiente}</Badge> · scade {String(test.scadeIl || "").slice(0, 10)} · avvisi {test.avvisi ? "attivi" : "non configurati"}</p> : <p className="text-red-400">{test.error || "Verifica non riuscita"}</p>}</div>}
    </Card>
  );
}
